var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Trigger a file download programmatically by creating and utilizing a temporary `<a>` element.
 *
 * @example
 * downloadFile('https://dev.indico.io/my-file.csv')
 */
export function downloadFile(downloadUrl, filename) {
    const linkEl = document.createElement('a');
    linkEl.setAttribute('target', '_blank');
    linkEl.setAttribute('href', downloadUrl);
    linkEl.setAttribute('download', filename !== null && filename !== void 0 ? filename : '');
    linkEl.style.display = 'none';
    document.body.appendChild(linkEl);
    linkEl.click();
    document.body.removeChild(linkEl);
}
export function downloadBlobFile(downloadUrl, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(downloadUrl);
            if (!response.ok)
                throw new Error('Failed to fetch file');
            const blob = yield response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const linkEl = document.createElement('a');
            linkEl.setAttribute('target', '_blank');
            linkEl.setAttribute('href', blobUrl);
            linkEl.setAttribute('download', filename !== null && filename !== void 0 ? filename : '');
            linkEl.style.display = 'none';
            document.body.appendChild(linkEl);
            linkEl.click();
            document.body.removeChild(linkEl);
            URL.revokeObjectURL(blobUrl);
        }
        catch (error) {
            console.error('Download failed:', error);
        }
    });
}
//# sourceMappingURL=download.js.map